export default __webpack_public_path__ + "static/media/spin-the-wheel-banner-Img.bc78b98d.png";